
export { getAllThumbnails } from "./contentfulAPI/thumbnail.fetchers"
export { getLandingPage } from "./contentfulAPI/landingPage.fetchers"
export { getTag } from "./contentfulAPI/tag.fetchers"